import { render, staticRenderFns } from "./OrderUpdate.vue?vue&type=template&id=1562e01e&scoped=true"
import script from "./OrderUpdate.vue?vue&type=script&lang=js"
export * from "./OrderUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562e01e",
  null
  
)

export default component.exports